import { createAction, props } from '@ngrx/store';
import { User, UserListArgs } from 'src/shared/api';
import { TouchableControl } from 'src/shared/models/TouchableControl';

export const adminUserListDestroyed = createAction(
	'[Admin User] Admin User List Destroyed'
);

export const adminUsersLoaded = createAction(
	'[Admin User] Users Loaded',
	props<{ users: User[] }>()
);

export const errorLoadingAdminUsers = createAction(
	'[Admin User] Error Loading Users',
	props<{ error: any }>()
);

export const adminUserLoadedFromApi = createAction(
	'[Admin User] Admin User Loaded From Api',
	props<{ user: User }>()
);

export const adminUserLoadedFromStore = createAction(
	'[Admin User] Admin User Loaded From Store',
	props<{ user: User }>()
);

export const adminUserSelected = createAction(
	'[Admin User] Admin User Selected',
	props<{ selectedAdminUserId: string }>()
);

export const saveRequestedWithInvalidForm = createAction(
	'[Admin User] Save Requested With Invalid Form',
	props<{ controls: TouchableControl[] }>()
);

export const errorSavingAdminUser = createAction(
	'[Admin User] Error Saving Admin User',
	props<{ error: any }>()
);

export const adminUserSaved = createAction(
	'[Admin User] Admin User Saved',
	props<{ user: User }>()
);

export const adminUserDetailDestroyed = createAction(
	'[Admin User] Admin User Detail Destroyed'
);

export const saveRequested = createAction(
	'[Admin User] Save Requested',
	props<{ shouldStayOnPage: boolean; formValue: User }>()
);

export const filtersUpdated = createAction(
	'[Admin User] Filters Updated',
	props<{ filters: UserListArgs }>()
);
